import { useState, useEffect } from "react";
import axios from "axios";
import API from "utils/API";
import useToken from "useToken";

export default (period, category) => {
  const [data, setData] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const { token, setToken } = useToken();

  const formData = new FormData();
  formData.append("session_key", token);

  useEffect(() => {
    setLoading(true);
    setData([]);
    API.post(`get_overview?period=${period}&category_id=${category}`, formData)
      .then((res) => {
        setLoading(false);
        setData(res.data);
        setErrorMessage(null);
        /*
         */
      })
      .catch((err) => {
        setLoading(false);
        setData([]);
        setErrorMessage(err.message);
      });
  }, [period, category]);

  return [data, loading];
};
